import { EventEmitter } from 'events';
import _ from 'underscore';
import asyncSubscribe from 'async-subscribe';

function ObservableApi (emitter, apiFns) {
    var names = Object.keys(apiFns);
    var fns = names.reduce(function (acc, name) {
        acc[name] = asyncSubscribe(emitter, name, apiFns[name]);
        return acc;
    }, {});
    return fns;
}

// conncet our api functions to an event emitter
const observApi = apiFns => {
    var emitter = new EventEmitter();
    return {
        bus: emitter,
        actions: ObservableApi(emitter, apiFns)
    };
};

export default observApi